app.config(
    ['$urlRouterProvider', '$stateProvider',
        function config($urlRouterProvider, $stateProvider) {
            $stateProvider

                .state(
                    'export', {
                        controller: 'ExportController',
                        url: '/export?:lang:z:type',
                        templateUrl: 'application/templates/export.html'
                    }
                )
                .state('app', {
                    abstract: true,
                    url: '?:z',
                    controller: 'AppController',
                    templateUrl: 'application/templates/App/layout.html'
                })

                /***Consultation view, edit, correction, list , traduction**/
                .state(
                    'app.consultation', {
                        abstract: true,
                        controller: 'ConsultationController',
                        url: '/consultation?:lang',
                        templateUrl: 'application/templates/App/Consultation/consultation.html'
                    }
                )
                .state('app.consultation.view', {
                    controller: 'ConsultationViewController',
                    url: '/view?:id:index:sortKey:reverse:descpos',
                    templateUrl: 'application/templates/App/Consultation/view.html'
                })
                .state('app.consultation.flaneries', {
                    controller: 'ConsultationFlaneriesController',
                    controllerAs: 'vm',
                    url: '/flaneries?:id:index:sortKey:reverse:filter:countryId:CityId:UpdateDate:CreationDate:statusId:clid:langCode:Duration:descpos',
                    templateUrl: 'application/templates/App/Consultation/itinerary.html'
                })
                //this need to be deleted
                .state('app.consultation.walk', {
                    controller: 'ConsultationFlaneriesController',
                    controllerAs: 'vm',
                    url: '/walk?:id:index:sortKey:reverse:filter:countryId:CityId:UpdateDate:CreationDate:statusId:clid:langCode:Duration:descpos',
                    templateUrl: 'application/templates/App/Consultation/itinerary.html'
                })
                .state('app.consultation.district', {
                    controller: 'ConsultationDistrictController',
                    controllerAs: 'vm',
                    url: '/district?id:index:sortKey:reverse:descpos',
                    templateUrl: 'application/templates/App/Consultation/district.html'
                })
                .state('app.consultation.daily', {
                    controller: 'ConsultationDailyController',
                    url: '/daily',
                    templateUrl: 'application/templates/App/Consultation/daily.html'
                })
                .state('app.consultation.set', {
                    controller: 'SetController',
                    controllerAs: 'vm',
                    url: '/set?:id:index:sortKey:reverse:qc:descpos',
                    templateUrl: 'application/templates/App/Consultation/set.html'
                })

                .state('app.consultation.bio', {
                    controller: 'BioController',
                    controllerAs: 'vm',
                    url: '/bio?:id:index:sortKey:reverse:filter:countryId:CityName:UpdateDate:CreationDate:statusId:clid:langCode:descpos',
                    templateUrl: 'application/templates/App/Consultation/bio.html'
                })
                .state('app.consultation.edit', {
                    url: '/edit',
                    templateUrl: 'application/templates/App/Consultation/edit.html'
                })
                .state('app.consultation.correction', {
                    url: '/correction',
                    templateUrl: 'application/templates/App/Consultation/correction.html'
                })
                .state('app.consultation.history', {
                    url: '/history',
                    templateUrl: 'application/templates/App/Consultation/history.html'
                })
                .state('app.consultation.traduction', {
                    url: '/traduction',
                    templateUrl: 'application/templates/App/Consultation/traduction.html'
                })

                .state(
                    'app.list', {
                        abstract: true,
                        controller: 'ListController',
                        url: '/list?:lang',
                        templateUrl: 'application/templates/App/List/list.html'
                    }
                )
                .state('app.list.place', {
                    url: '/place?:mcd:pageno:sortkey:reverse:istopbaractive:searchText:search:gsearch',
                    views: {
                        'content': {
                            controller: 'PlaceListController',
                            controllerAs: 'vm',
                            templateUrl: 'application/templates/App/List/place/content.html'
                        },
                        'sidebar': {
                            controller: 'ListController',
                            templateUrl: 'application/templates/App/List/place/sidebar.html'
                        }
                    }
                })
                .state('app.list.guest', {
                    url: '/guest?:qc:pageno:sortkey:reverse:istopbaractive:searchText:search:gsearch',
                    views: {
                        'content': {
                            controller: 'BioListController',
                            controllerAs: 'vm',
                            templateUrl: 'application/templates/App/List/guest/content.html'
                        },
                        'sidebar': {
                            controller: 'ListController',
                            templateUrl: 'application/templates/App/List/guest/sidebar.html'
                        }
                    }
                })

                .state('app.list.itinary', {
                    url: '/itinary?:qc:pageno:sortkey:reverse:istopbaractive:searchText:search:gsearch',
                    views: {
                        'content': {
                            controller: 'ItineraryListController',
                            controllerAs: 'vm',
                            templateUrl: 'application/templates/App/List/itinary/content.html'
                        },
                        'sidebar': {
                            controller: 'ListController',
                            templateUrl: 'application/templates/App/List/itinary/sidebar.html'
                        }
                    }
                })

                .state('app.list.walk', {
                    url: '/walk?:qc:pageno:sortkey:reverse:istopbaractive:searchText:search:gsearch',
                    views: {
                        'content': {
                            controller: 'WalkListController',
                            controllerAs: 'vm',
                            templateUrl: 'application/templates/App/List/walk/content.html'
                        },
                        'sidebar': {
                            controller: 'ListController',
                            templateUrl: 'application/templates/App/List/walk/sidebar.html'
                        }
                    }
                })

                .state('app.list.district', {
                    url: '/district?:pageno:sortkey:reverse:istopbaractive:searchText:search:gsearch',
                    views: {
                        'content': {
                            controller: 'DistrictListController',
                            controllerAs: 'vm',
                            templateUrl: 'application/templates/App/List/district/content.html'
                        },
                        'sidebar': {
                            controller: 'ListController',
                            templateUrl: 'application/templates/App/List/district/sidebar.html'
                        }
                    }
                })
                .state('app.list.set', {
                    url: '/set?:qc:pageno:sortkey:reverse:istopbaractive:searchText:search:gsearch',
                    views: {
                        'content': {
                            controller: 'SetListController',
                            controllerAs: 'vm',
                            templateUrl: 'application/templates/App/List/set/content.html'
                        },
                        'sidebar': {
                            controller: 'ListController',
                            templateUrl: 'application/templates/App/List/set/sidebar.html'
                        }
                    }
                })

                .state(
                    'app.search', {
                        url: '/search',
                        controller: 'SearchController',
                        templateUrl: 'application/templates/App/Search/search.html'
                    }
                )

                .state(
                    'app.correction', {
                        abstract: true,
                        controller: 'ConsultationController',
                        url: '/correction',
                        templateUrl: 'application/templates/App/Consultation/consultation.html'
                    }
                )
                .state('app.correction.place', {
                    controller: 'PlaceCorrectionController',
                    url: '/place?id:lang:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Correction/place.html'
                })
                .state('app.correction.bio', {
                    controller: 'BioCorrectionController',
                    controllerAs: 'vm',
                    url: '/bio?id:lang:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Correction/Bio.html'
                })
                .state('app.correction.itinary', {
                    controller: 'ItineraryCorrectionController',
                    controllerAs: 'vm',
                    url: '/itinary?:id:lang:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Correction/itinerary.html'
                })
                .state('app.correction.walk', {
                    controller: 'ItineraryCorrectionController',
                    controllerAs: 'vm',
                    url: '/walk?:id:lang:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Correction/itinerary.html'
                })

                .state('app.correction.set', {
                    controller: 'SetCorrectionController',
                    controllerAs: 'vm',
                    url: '/set?:id:lang:index:sortKey:reverse:qc',
                    templateUrl: 'application/templates/App/Correction/Set.html'
                })
                .state('app.correction.district', {
                    controller: 'DistrictCorrectionController',
                    controllerAs: 'vm',
                    url: '/district?:id:lang:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Correction/district.html'
                })

                .state(
                    'app.traduction', {
                        abstract: true,
                        controller: 'ConsultationController',
                        url: '/traduction',
                        templateUrl: 'application/templates/App/Consultation/consultation.html'
                    }
                )
                .state('app.traduction.place', {
                    controller: 'PlaceTranslationController',
                    url: '/place?:lang:lang2:id:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Traduction/place.html'
                })
                .state('app.traduction.bio', {
                    controller: 'BioTranslationController',
                    controllerAs: 'vm',
                    url: '/bio?:lang:lang2:id:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Traduction/Bio.html'
                })
                .state('app.traduction.itinary', {
                    controller: 'ItineraryTranslationController',
                    controllerAs: 'vm',
                    url: '/itinary?:lang:lang2:id:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Traduction/itinerary.html'
                })
                .state('app.traduction.walk', {
                    controller: 'ItineraryTranslationController',
                    controllerAs: 'vm',
                    url: '/walk?:lang:lang2:id:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Traduction/itinerary.html'
                })
                .state('app.traduction.district', {
                    controller: 'DistrictTranslationController',
                    controllerAs: 'vm',
                    url: '/district?:lang:lang2:id:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Traduction/district.html'
                })
                .state('app.traduction.set', {
                    controller: 'SetTranslationController',
                    controllerAs: 'vm',
                    url: '/set?:lang:lang2:id:index:sortKey:reverse:qc',
                    templateUrl: 'application/templates/App/Traduction/set.html'
                })

                //Admin pages
                .state('app.adminMain', {
                    abstract: true,
                    url: '/admin/main',
                    templateUrl: 'application/templates/App/Admin/admin-main.html'
                })
                .state('app.adminMain.field', {
                    controller: 'AdminGeneralController',
                    controllerAs: 'vm',
                    url: '/field',
                    templateUrl: 'application/templates/App/Admin/admin-main-field.html'
                })
                .state('app.adminMain.text', {
                    controller: 'AdminGeneralController',
                    controllerAs: 'vm',
                    url: '/text',
                    templateUrl: 'application/templates/App/Admin/admin-main-text.html'
                })
                .state('app.adminUser', {
                    abstract: true,
                    url: '/admin/user',
                    templateUrl: 'application/templates/App/Admin/admin-user.html'
                })
                .state('app.adminUser.info', {
                    controller: 'AdminUserInfosController',
                    controllerAs: 'vm',
                    url: '/info?:id',
                    templateUrl: 'application/templates/App/Admin/admin-user-info.html'
                })
                .state('app.adminUser.role', {
                    controller: 'AdminUserInfosController',
                    controllerAs: 'vm',
                    url: '/role?:id',
                    templateUrl: 'application/templates/App/Admin/admin-user-role.html'
                })
                .state('app.admin-creation-utilisateur', {
                    controller: 'AdminUserCreationController',
                    controllerAs: 'vm',
                    url: '/admin/admin-creation-utilisateur',
                    templateUrl: 'application/templates/App/Admin/admin-creation-utilisateur.html'
                })
                .state('app.admin-creation-mdp', {
                    controller: '',
                    url: '/admin/admin-creation-mdp',
                    templateUrl: 'application/templates/App/Admin/admin-creation-mdp.html'
                })
                .state('app.admin-liste-utilisateur', {
                    controller: 'AdminUserListController',
                    controllerAs: 'vm',
                    url: '/admin/admin-liste-utilisateur',
                    templateUrl: 'application/templates/App/Admin/admin-liste-utilisateur.html'
                })
                .state('app.adminCity', {
                    abstract: true,
                    url: '/admin/city?:lang',
                    templateUrl: 'application/templates/App/Admin/admin-city.html'
                })
                .state('app.adminCity.info', {
                    controller: 'AdminZoneInfosController',
                    controllerAs: 'vm',
                    url: '/info',
                    templateUrl: 'application/templates/App/Admin/admin-city-info.html'
                })
                .state('app.adminCity.rubric', {
                    controller: 'AdminZoneRubricController',
                    controllerAs: 'vm',
                    url: '/rubric',
                    templateUrl: 'application/templates/App/Admin/admin-city-rubric.html'
                })
                .state('app.adminCity.team', {
                    controller: 'AdminZoneTeamController',
                    controllerAs: 'vm',
                    url: '/team',
                    templateUrl: 'application/templates/App/Admin/admin-city-team.html'
                })
                .state('app.admin-creation-ville', {
                    controller: 'AdminCityCreationController',
                    controllerAs: 'vm',
                    url: '/admin/admin-creation-ville',
                    templateUrl: 'application/templates/App/Admin/admin-creation-ville.html'
                })
                .state('app.admin-liste-ville', {
                    controller: 'AdminCityListController',
                    controllerAs: 'vm',
                    url: '/admin/admin-liste-ville',
                    templateUrl: 'application/templates/App/Admin/admin-liste-ville.html'
                })

                .state(
                    'app.home', {
                        controller: 'HomeController',
                        controllerAs: 'vm',
                        url: '/home',
                        templateUrl: 'application/templates/dashboard.html'
                    }
                )

                //.state('app.dashboard', {
                //    controller: '',
                //    url: '/dashboard',
                //    templateUrl: 'application/templates/App/Admin/dashboard.html'
                //})
                .state('app.download', {
                    abstract: true,
                    controller: 'DownloadController',
                    url: '/download?path:mode',
                    templateUrl: 'application/templates/App/Admin/download.html'
                })
                .state('app.download.list', {
                    url: '?:mode',
                    templateUrl: function ($stateParams) {
                        if ($stateParams.mode === 'mozaic')
                            return 'application/templates/App/Admin/download-mozaic.html';
                        return 'application/templates/App/Admin/download-list.html';
                    }
                })
                .state('app.help', {
                    abstract: true,
                    controller: 'HelpController',
                    url: '/help?path',
                    templateUrl: 'application/templates/App/Help/help.html'
                })
                .state('app.help.list', {
                    url: '?:mode',
                    templateUrl: function ($stateParams) {
                        if ($stateParams.mode === 'list')
                            return 'application/templates/App/Help/help-list.html';

                        return 'application/templates/App/Help/help-mozaic.html';

                    }
                })
                .state('app.stockingvisuel', {
                    abstract: true,
                    controller: 'StockingVisuelController',
                    url: '/stockingvisuel?path',
                    templateUrl: 'application/templates/App/Admin/stocking-visuel.html'
                })
                .state('app.stockingvisuel.list', {
                    url: '?:mode',
                    templateUrl: function ($stateParams) {
                        if ($stateParams.mode === 'list')
                            return 'application/templates/App/Admin/stocking-visuel-list.html';

                        return 'application/templates/App/Admin/stocking-visuel-mozaic.html';
                    }
                })
                .state(
                    'app.creationPlace', {
                        abstract: true,
                        controller: 'PlaceCreationController',
                        url: '/creation?:mcd',
                        templateUrl: 'application/templates/App/Creation/creation.html'
                    }
                )
                .state('app.creationPlace.name', {
                    //  controller: 'PlaceCreationController',
                    url: '/place/name',
                    templateUrl: 'application/templates/App/Creation/place/name.html'
                })
                .state('app.creationPlace.geolocalisation', {
                    //  controller: 'PlaceCreationController',
                    url: '/place/geolocalisation',
                    templateUrl: 'application/templates/App/Creation/place/geolocalisation.html'
                })
                .state('app.creationPlace.contacts', {
                    //  controller: 'PlaceCreationController',
                    url: '/place/contacts',
                    templateUrl: 'application/templates/App/Creation/place/contacts.html'
                })
                .state('app.creationPlace.horaires', {
                    //  controller: 'PlaceCreationController',
                    url: '/place/horaires',
                    templateUrl: 'application/templates/App/Creation/place/horaires.html'
                })
                .state('app.creationPlace.infos', {
                    //  controller: 'PlaceCreationController',
                    url: '/place/infos',
                    templateUrl: 'application/templates/App/Creation/place/infos.html'
                })
                .state('app.creationPlace.distribution', {
                    //  controller: 'PlaceCreationController',
                    url: '/place/distribution',
                    templateUrl: 'application/templates/App/Creation/place/distribution.html'
                })
                .state('app.creationPlace.classification', {
                    //  controller: 'PlaceCreationController',
                    url: '/place/classification',
                    templateUrl: 'application/templates/App/Creation/place/classification.html'
                })
                .state('app.creationPlace.descriptif', {
                    // controller: 'PlaceCreationController',
                    url: '/place/descriptif',
                    templateUrl: 'application/templates/App/Creation/place/descriptif.html'
                })
                .state('app.creation.visuel', {
                    // controller: 'PlaceCreationController',
                    url: '/place/visuel',
                    templateUrl: 'application/templates/App/Creation/place/visuel.html'
                })
                .state('app.creation.sources', {
                    //  controller: 'PlaceCreationController',
                    url: '/place/sources',
                    templateUrl: 'application/templates/App/Creation/place/sources.html'
                })

                .state(
                    'app.creationDistrict', {
                        abstract: true,
                        controller: 'DistrictCreationController',
                        controllerAs: 'vm',
                        url: '/creation/district',
                        templateUrl: 'application/templates/App/Creation/creation.html'
                    }
                )
                .state('app.creationDistrict.new', {
                    url: '/new',
                    templateUrl: 'application/templates/App/Creation/district/new.html'
                })
                .state('app.creationDistrict.contacts', {
                    url: '/contacts',
                    templateUrl: 'application/templates/App/Creation/district/contacts.html'
                })
                .state('app.creationDistrict.classification', {
                    url: '/classification',
                    templateUrl: 'application/templates/App/Creation/district/classification.html'
                })
                .state('app.creationDistrict.descriptif', {
                    url: '/descriptif',
                    templateUrl: 'application/templates/App/Creation/district/descriptif.html'
                })
                .state('app.creationDistrict.events', {
                    url: '/events',
                    templateUrl: 'application/templates/App/Creation/district/events.html'
                })
                .state('app.creationDistrict.visuel', {
                    url: '/visuel',
                    templateUrl: 'application/templates/App/Creation/district/visuel.html'
                })
                .state('app.creationDistrict.sources', {
                    url: '/sources',
                    templateUrl: 'application/templates/App/Creation/district/sources.html'
                })

                .state(
                    'app.creationGuest', {
                        abstract: true,
                        controller: 'BioCreationController',
                        controllerAs: 'vm',
                        url: '/creation/bio?qc',
                        templateUrl: 'application/templates/App/Creation/creation.html'
                    }
                )
                .state('app.creationGuest.biographie', {
                    url: '/biographie',
                    templateUrl: 'application/templates/App/Creation/bio/biographie.html'
                })
                .state('app.creationGuest.contacts', {
                    url: '/contacts',
                    templateUrl: 'application/templates/App/Creation/bio/contacts.html'
                })
                .state('app.creationGuest.infos', {
                    url: '/infos',
                    templateUrl: 'application/templates/App/Creation/bio/infos.html'
                })
                .state('app.creationGuest.classification', {
                    url: '/classification',
                    templateUrl: 'application/templates/App/Creation/bio/classification.html'
                })
                .state('app.creationGuest.descriptif', {
                    url: '/descriptif',
                    templateUrl: 'application/templates/App/Creation/bio/descriptif.html'
                })
                .state('app.creationGuest.oeuvres', {
                    url: '/oeuvres',
                    templateUrl: 'application/templates/App/Creation/bio/oeuvres.html'
                })
                .state('app.creationGuest.parcours', {
                    url: '/parcours',
                    templateUrl: 'application/templates/App/Creation/bio/parcours.html'
                })
                .state('app.creationGuest.famille', {
                    url: '/famille',
                    templateUrl: 'application/templates/App/Creation/bio/famille.html'
                })
                .state('app.creationGuest.events', {
                    url: '/events',
                    templateUrl: 'application/templates/App/Creation/bio/events.html'
                })
                .state('app.creationGuest.visuel', {
                    url: '/visuel',
                    templateUrl: 'application/templates/App/Creation/bio/visuel.html'
                })
                .state('app.creationGuest.sources', {
                    url: '/sources',
                    templateUrl: 'application/templates/App/Creation/bio/sources.html'
                })

                .state(
                    'app.creationSet', {
                        abstract: true,
                        controller: 'SetCreationController',
                        controllerAs: 'vm',
                        url: '/creation/set?qc',
                        templateUrl: 'application/templates/App/Creation/creation.html'
                    }
                )
                .state('app.creationSet.new', {
                    url: '/new',
                    templateUrl: 'application/templates/App/Creation/set/new.html'
                })
                .state('app.creationSet.contacts', {
                    url: '/contacts',
                    templateUrl: 'application/templates/App/Creation/set/contacts.html'
                })
                .state('app.creationSet.classification', {
                    url: '/classification',
                    templateUrl: 'application/templates/App/Creation/set/classification.html'
                })
                .state('app.creationSet.descriptif', {
                    url: '/descriptif',
                    templateUrl: 'application/templates/App/Creation/set/descriptif.html'
                })
                .state('app.creationSet.objets', {
                    url: '/objets',
                    templateUrl: 'application/templates/App/Creation/set/objets.html'
                })
                .state('app.creationSet.visuel', {
                    url: '/visuel',
                    templateUrl: 'application/templates/App/Creation/set/visuel.html'
                })
                .state('app.creationSet.sources', {
                    url: '/sources',
                    templateUrl: 'application/templates/App/Creation/set/sources.html'
                })

                .state(
                    'app.creationItinerary', {
                        abstract: true,
                        controller: 'ItineraryCreationController',
                        controllerAs: 'vm',
                        url: '/creation/itinerary?qc',
                        templateUrl: 'application/templates/App/Creation/creation.html'
                    }
                )
                .state('app.creationItinerary.name', {
                    url: '/name',
                    templateUrl: 'application/templates/App/Creation/itinerary/name.html'
                })
                .state('app.creationItinerary.contacts', {
                    url: '/contacts',
                    templateUrl: 'application/templates/App/Creation/itinerary/contacts.html'
                })
                .state('app.creationItinerary.infos', {
                    url: '/infos',
                    templateUrl: 'application/templates/App/Creation/itinerary/infos.html'
                })
                .state('app.creationItinerary.classification', {
                    url: '/classification',
                    templateUrl: 'application/templates/App/Creation/itinerary/classification.html'
                })
                .state('app.creationItinerary.descriptif', {
                    url: '/descriptif',
                    templateUrl: 'application/templates/App/Creation/itinerary/descriptif.html'
                })
                .state('app.creationItinerary.steps', {
                    url: '/steps',
                    templateUrl: 'application/templates/App/Creation/itinerary/steps.html'
                })
                .state('app.creationItinerary.events', {
                    url: '/events',
                    templateUrl: 'application/templates/App/Creation/itinerary/events.html'
                })
                .state('app.creationItinerary.visuel', {
                    url: '/visuel',
                    templateUrl: 'application/templates/App/Creation/itinerary/visuel.html'
                })
                .state('app.creationItinerary.sources', {
                    url: '/sources',
                    templateUrl: 'application/templates/App/Creation/itinerary/sources.html'
                })

                .state(
                    'app.creationWalk', {
                        abstract: true,
                        controller: 'WalkController',
                        url: '/creation/walk',
                        templateUrl: 'application/templates/App/Creation/creation.html'
                    }
                )
                .state('app.creationWalk.name', {
                    url: '/name',
                    templateUrl: 'application/templates/App/Creation/walk/name.html'
                })
                .state('app.creationWalk.contacts', {
                    url: '/contacts',
                    templateUrl: 'application/templates/App/Creation/walk/contacts.html'
                })
                .state('app.creationWalk.infos', {
                    url: '/infos',
                    templateUrl: 'application/templates/App/Creation/walk/infos.html'
                })
                .state('app.creationWalk.classification', {
                    url: '/classification',
                    templateUrl: 'application/templates/App/Creation/walk/classification.html'
                })
                .state('app.creationWalk.descriptif', {
                    url: '/descriptif',
                    templateUrl: 'application/templates/App/Creation/walk/descriptif.html'
                })
                .state('app.creationWalk.steps', {
                    url: '/steps',
                    templateUrl: 'application/templates/App/Creation/walk/steps.html'
                })
                .state('app.creationWalk.events', {
                    url: '/events',
                    templateUrl: 'application/templates/App/Creation/walk/events.html'
                })
                .state('app.creationWalk.visuel', {
                    url: '/visuel',
                    templateUrl: 'application/templates/App/Creation/walk/visuel.html'
                })
                .state('app.creationWalk.sources', {
                    url: '/sources',
                    templateUrl: 'application/templates/App/Creation/walk/sources.html'
                })

                //Preview
                .state('previewset', {
                    controller: 'PreviewController',
                    controllerAs: 'vm',
                    url: '/preview?:type:id:lang:index:sortKey:reverse',
                    templateUrl: 'application/templates/App/Preview/Preview.html'
                })
                .state('shareurl', {
                    controller: 'ShareUrlController',
                    controllerAs: 'vm',
                    url: '/shareurl?:guid:lang',
                    templateUrl: 'application/templates/App/Preview/ShareUrl.html'
                })

                .state('app.consultation.diff', {
                    controller: 'DiffController',
                    controllerAs: 'vm',
                    url: '/diff?:id:lang',
                    templateUrl: 'application/templates/App/Consultation/diff.html'
                })
                .state('login', {
                    url: '/login?:lang',
                    controller: 'LoginController',
                    controllerAs: 'vm',
                    templateUrl: 'application/templates/App/User/login.html'
                })
                .state('createpassword', {
                    controller: 'PasswordController',
                    controllerAs: 'vm',
                    url: '/createpassword?:guid:lang',
                    templateUrl: 'application/templates/password.html'
                })
                .state('resetpasswordvalidateemail', {
                    controller: 'ResetPasswordController',
                    controllerAs: 'vm',
                    url: '/resetpasswordvalidateemail?:lang',
                    templateUrl: 'application/templates/reinitialisationemail.html'
                })
                .state('resetpassword', {
                    controller: 'ResetPasswordController',
                    controllerAs: 'vm',
                    url: '/resetpassword?:guid:lang',
                    templateUrl: 'application/templates/reinitialisationpwd.html'
                })
                .state('mentionslegales', {
                    controller: 'LoginController',
                    controllerAs: 'vm',
                    url: '/mentionslegales?:lang',
                    templateUrl: 'application/templates/mentionslegales.html'
                })
            ;
            $urlRouterProvider.otherwise('login?lang=fr');
        }
    ]
);

appexport.config(
    ['$urlRouterProvider', '$stateProvider',
        function config($urlRouterProvider, $stateProvider) {
            $stateProvider

                .state(
                    'export', {
                        controller: 'ExportController',
                        url: '/export?:lang:z',
                        templateUrl: 'application/templates/export.html'
                    })

                     .state(
                    'exportgeneric', {
                        controller: 'ExportController',
                        controllerAs: 'vm',
                        url: '/exportgeneric?:langinterface:lang:z:type:objecttype:search:gsearch:qc:selectedid:mcd:sortkey:reverse',
                        templateUrl: 'application/templates/exportgeneric.html'
                    }
                );
        }
    ]
);